<div #headerContainer>
  <div
    *ngIf="menu | productMenuBasicMethod: 'getSectionTitle' : section | exists"
    class="section-title"
    [style.background-color]="section?.metadata?.productsHeaderBackgroundColor"
    [style.background-size]="'cover'"
    [style.zoom]="menu?.menuOptions?.productZoom || 1.0"
    [ngStyle]="{
      'background-image': headerBackgroundAsset$ | async
    }">
    <div class="section-title-text">{{ menu | productMenuBasicMethod: 'getSectionTitle' : section }}</div>
    <div
      *ngIf="
        (menu | productMenuBasicMethod: 'getShowSectionHeaderColorAsIcon') &&
        (section?.metadata?.productsHeaderBackgroundColor | exists)
      "
      class="section-title-icon"
      [style.background-color]="section?.metadata?.productsHeaderBackgroundColor"></div>
  </div>
  <div
    class="section-header-container"
    [style.zoom]="menu?.menuOptions?.productZoom || 1.0"
    [style.border-bottom-color]="menu | productMenuBasicMethod: 'getSectionTitleUnderlineColor' : section"
    [ngClass]="{
      'section-header-bottom-border': menu | productMenuBasicMethod: 'getSectionHeaderUnderlined'
    }">
    <ng-container *ngFor="let col of columnVMs">
      <div
        *ngIf="menu | getShouldInflateColumnHeaderForRow: section : col : sectionRowViewModels"
        class="section-column"
        [ngClass]="{ 'section-column-title': col.columnType === Types.SectionColumnProductInfoType.ProductTitle }"
        [style.width.%]="col.widthPercentage"
        [hidden]="menu | getShouldHideHeaderContent: section : col">
        <app-header-column-variant-price
          *ngIf="col.columnType === Types.SectionColumnProductInfoType.VariantPrice"
          [menu]="menu"
          [section]="section"
          [colVm]="col">
        </app-header-column-variant-price>
        <app-header-column-variant-secondary-price
          *ngIf="col.columnType === Types.SectionColumnProductInfoType.VariantSecondaryPrice"
          [menu]="menu"
          [section]="section"
          [colVm]="col">
        </app-header-column-variant-secondary-price>
        <app-header-column-quantity-and-size
          *ngIf="col.columnType === Types.SectionColumnProductInfoType.QuantityAndSize"
          [menu]="menu"
          [section]="section"
          [colVm]="col">
        </app-header-column-quantity-and-size>
        <app-header-column-quantity
          *ngIf="col.columnType === Types.SectionColumnProductInfoType.Quantity"
          [menu]="menu"
          [section]="section"
          [colVm]="col">
        </app-header-column-quantity>
        <app-header-column-size
          *ngIf="col.columnType === Types.SectionColumnProductInfoType.Size"
          [menu]="menu"
          [section]="section"
          [colVm]="col">
        </app-header-column-size>
        <app-header-column-strain-type
          *ngIf="col.columnType === Types.SectionColumnProductInfoType.StrainType"
          [menu]="menu"
          [section]="section"
          [colVm]="col">
        </app-header-column-strain-type>
        <app-header-column-strain
          *ngIf="col?.columnType === Types.SectionColumnProductInfoType.Strain"
          [menu]="menu"
          [section]="section"
          [colVm]="col">
        </app-header-column-strain>
        <app-header-column-cannabinoid
          *ngIf="col?.columnType | isCannabinoidColumn as cannabinoidColumnType"
          [menu]="menu"
          [section]="section"
          [colVm]="col"
          [sectionRowViewModels]="sectionRowViewModels"
          [cannabinoidColumnType]="cannabinoidColumnType">
        </app-header-column-cannabinoid>
        <app-header-column-terpene
          *ngIf="col?.columnType | isTerpeneColumn as terpeneColumnType"
          [menu]="menu"
          [section]="section"
          [colVm]="col"
          [sectionRowViewModels]="sectionRowViewModels"
          [terpeneColumnType]="terpeneColumnType">
        </app-header-column-terpene>
        <app-header-column-producer
          *ngIf="col.columnType === Types.SectionColumnProductInfoType.Producer"
          [menu]="menu"
          [section]="section"
          [colVm]="col">
        </app-header-column-producer>
        <app-header-column-badge
          *ngIf="col.columnType === Types.SectionColumnProductInfoType.Badge"
          [menu]="menu"
          [section]="section"
          [colVm]="col">
        </app-header-column-badge>
        <app-header-column-lineage
          *ngIf="col.columnType === Types.SectionColumnProductInfoType.Lineage"
          [menu]="menu"
          [section]="section"
          [colVm]="col">
        </app-header-column-lineage>
        <app-header-column-brand
          *ngIf="col.columnType === Types.SectionColumnProductInfoType.Brand"
          [menu]="menu"
          [section]="section"
          [colVm]="col">
        </app-header-column-brand>
      </div>
    </ng-container>
  </div>
</div>
